import { gql } from '@apollo/client';

export const MESSAGE_HISTORY_FILTER_OPTIONS_GQL = gql`
  query MessageHistoryPage_GetFilterOptions {
    organization(where: { deleted_at: { _is_null: true } }, order_by: { name: asc }) {
      id
      name
    }
    farm(where: { deleted_at: { _is_null: true } }, order_by: { name: asc }) {
      id
      name
      organization_id
    }
  }
`;

export const MESSAGE_HISTORY_ORG_USERS_GQL = gql`
  query MessageHistoryPage_GetOrgUsers($organization_ids: [uuid!]!) {
    barn_users: user_barn(
      where: { barn: { deleted_at: { _is_null: true }, organization_id: { _in: $organization_ids } } }
      order_by: { user: { name: asc } }
    ) {
      user {
        id
        name
        email
      }
    }
    organization_users: user_organization(
      where: { organization_id: { _in: $organization_ids }, deleted_at: { _is_null: true } }
      order_by: { user: { name: asc } }
    ) {
      user {
        id
        name
        email
      }
    }
  }
`;

export const MESSAGE_HISTORY_MESSAGES_GQL = gql`
  query MessageHistoryPage_GetMessages(
    $limit: Int!
    $offset: Int!
    $where: message_bool_exp!
    $order_by: [message_order_by!]!
  ) {
    message(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      sent_at
      transported_as
      user_id
      status
      sms_notification_statuses(order_by: { occurred_at: desc }, limit: 20) {
        status
        occurred_at
      }
      email_notification_statuses(order_by: { occurred_at: desc }, limit: 20) {
        status
        occurred_at
      }
      push_notification_receipts(order_by: { created_at: desc }, limit: 20) {
        receipt_status
        receipt_completed_at
        receipt_message
      }
      user {
        id
        name
      }
      fault_messages {
        reason
        fault {
          id
          code
          device {
            type
            bin_controller {
              bin_controller_bins(
                where: { deleted_at: { _is_null: true } }
                order_by: { index: asc }
              ) {
                bin {
                  name
                }
              }
              bin_set {
                farm {
                  id
                  name
                  organization {
                    id
                    name
                  }
                }
              }
            }
            device_assignments(
              where: { deleted_at: { _is_null: true }, ended_at: { _is_null: true } }
              limit: 1
            ) {
              feed_line {
                id
                name
                farm {
                  id
                  name
                  organization {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const MESSAGE_HISTORY_CHART_DATA_GQL = gql`
  query MessageHistoryPage_ChartData(
    $p_from: bigint!
    $p_to: bigint!
    $p_time_zone: String!
    $p_series_by: String!
    $p_org_ids: _uuid!
    $p_barn_ids: _uuid!
    $p_user_ids: _uuid!
    $p_modes: _text!
    $p_types: _int4!
  ) {
    message_history_chart_data(
      args: {
        p_from: $p_from
        p_to: $p_to
        p_time_zone: $p_time_zone
        p_series_by: $p_series_by
        p_org_ids: $p_org_ids
        p_barn_ids: $p_barn_ids
        p_user_ids: $p_user_ids
        p_modes: $p_modes
        p_types: $p_types
      }
    ) {
      bucket_start
      series_key
      series_label
      message_count
    }
  }
`;
